import { setPublicPath } from 'systemjs-webpack-interop'

setPublicPath('@coderhouse/common')
